import { BaserowClient } from "./baserow-client";

/**
 * Operations for managing Baserow integrations.
 */
export class IntegrationOperations {
  constructor(private client: BaserowClient) {}
  
  // Integration methods will be implemented here
} 